<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Select your region
  
  .mb-5.has-text-left.text-white-on-dark
    span Be sure to select the closest server to your geographic location, or simply use our global server:

  .features.address-info
    .box-container
      .element-box-container.is-best(@click="select(algorithm.globalServer)")
        span.tag Recommended
        span.name.server {{ algorithm.globalServer.description }}
        br
        span.explanation By using the global server we will auto select the closest server to your location
        br
        span.url {{ algorithm.globalServer.url }}
    .columns.is-multiline.features.jc-center
      .column.is-half(v-for="o in algorithm.alternativeServers")
        .box-container
          .element-box-container(@click="select(o)")
            .region-image
              img(:src="'/img/region/' + o.country + '.png'")
            span.name.server {{ o.description }}
            br
            span.url {{ o.url }}

  .feature-helvetica.step-explanation
    .mt-10
      span You may try running a ping command directly from your console to check for the best (lowest) latency server:

    .articles
      router-link.article-mini(to="/support/article/how-to-run-a-ping-command", target="_blank")
        .article-inner
          .article-title
            span  How to run a ping command
          span.icon
            i.fa.fa-external-link
    
    
    
  
          
</template>

<script>
export default {
  name: 'c_step_region',
  props: ['mode', 'algorithm'],
  data () {
    return {
    }
  },
  created () {
    let vm = this
    if (vm.mode === 'basic') {
      vm.$emit('selected', vm.algorithm.globalServer)
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    select (region) {
      let vm = this
      vm.$emit('selected', region)
    }
  }
}
</script>

<style lang="stylus" scoped>
.region-image
  margin: auto
  display flex
  justify-content center
  align-items center
  width 50px
  margin-bottom 15px
.url
  font-size 13px
.features
  .box-container
    margin-top 10px
    .element-box-container
      margin 0
      max-height 130px
      &.is-best
        margin-bottom 10px
      .server
        font-size: 15px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
      .explanation
        font-size 13px
    .is-best
      position relative 
      border 5px solid #b6ffb6
      &:hover
        box-shadow 0 0 20px -10px
      .tag
        border-radius 0px
        background-color #b6ffb6
        font-weight bold
        display inline-block
        position absolute
        top -1px
        left -3px
        padding-top 2px
  .column
    padding-bottom 0px
  .step-explanation
    margin-top 30px
    margin-bottom 0px
.jc-center
  justify-content center
@media (max-width: 768px)
  .step-explanation
    margin-top 20px
  .features
    .box-container
      margin-top 0px
      .element-box-container
        max-height fit-content
</style>



// WEBPACK FOOTER //
// c_step_region.vue?5361e06b